import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const registerScientist = (payload) =>
  api.post("/scientists/register", payload).then((r) => r.data);

export const getScientistProfile = (handle) =>
  api.get(`/scientists/${handle}`).then((r) => r.data);

export const createEntry = (payload) =>
  api.post("/entries", payload).then((r) => r.data);

export const getGlobalFeed = (limit = 25) =>
  api.get(`/entries/feed?limit=${limit}`).then((r) => r.data);

export const getLeaderboard = (limit = 20) =>
  api.get(`/leaderboard?limit=${limit}`).then((r) => r.data);

export const getGlobalStats = () =>
  api.get("/stats/global").then((r) => r.data);

export const askSean = (session_id, message) =>
  api.post("/ask-sean", { session_id, message }).then((r) => r.data);

export const getChatHistory = (session_id) =>
  api.get(`/ask-sean/${session_id}`).then((r) => r.data);

export const generateMisinfo = (difficulty = "easy") =>
  api.post(`/misinfo/generate?difficulty=${encodeURIComponent(difficulty)}`).then((r) => r.data);

export const checkMisinfo = (claim_id, answer, scientist_handle) =>
  api
    .post("/misinfo/check", { claim_id, answer, scientist_handle })
    .then((r) => r.data);

export const recommendBooks = (payload) =>
  api.post("/books/recommend", payload).then((r) => r.data);

export const getDailyMission = () =>
  api.get("/daily-mission").then((r) => r.data);

export const getGenres = () => api.get("/genres").then((r) => r.data);

export const listPassages = () => api.get("/sprints/passages").then((r) => r.data);
export const getPassage = (id) => api.get(`/sprints/passages/${id}`).then((r) => r.data);
export const submitSprint = (payload) => api.post("/sprints", payload).then((r) => r.data);
export const sprintLeaderboard = (limit = 20) =>
  api.get(`/sprints/leaderboard?limit=${limit}`).then((r) => r.data);

export const submitBooking = (payload) =>
  api.post("/bookings", payload).then((r) => r.data);

export const requestBookingCode = (payload) =>
  api.post("/bookings/request-code", payload).then((r) => r.data);

export const verifyBookingCode = (contact_email, code) =>
  api.post("/bookings/verify-code", { contact_email, code }).then((r) => r.data);

// ----- Sean's Post Studio -----
export const seanLogin = (key) =>
  api.post("/sean/login", null, { headers: { "X-Sean-Key": key } }).then((r) => r.data);

export const seanCreatePost = (key, payload) =>
  api.post("/sean/posts", payload, { headers: { "X-Sean-Key": key } }).then((r) => r.data);

export const seanListPosts = (limit = 25) =>
  api.get(`/sean/posts?limit=${limit}`).then((r) => r.data);

export const getChannelVideos = (limit = 15) =>
  api.get(`/youtube/channel-videos?limit=${limit}`).then((r) => r.data);

export const seanDeletePost = (key, id) =>
  api.delete(`/sean/posts/${id}`, { headers: { "X-Sean-Key": key } }).then((r) => r.data);

export const getStories = () => api.get("/sean/stories").then((r) => r.data);

export const mediaSrc = (path) => (path ? `${BACKEND_URL}${path}` : null);

// Chunked upload (keeps each request small enough for the proxy). onProgress gets 0–100.
export async function seanUploadFile(key, file, onProgress) {
  const headers = { "X-Sean-Key": key };
  const { upload_id, chunk_size } = await api
    .post("/sean/uploads/init", { filename: file.name, content_type: file.type, size: file.size }, { headers })
    .then((r) => r.data);
  const total = Math.ceil(file.size / chunk_size);
  for (let i = 0; i < total; i++) {
    const chunk = file.slice(i * chunk_size, (i + 1) * chunk_size);
    await api.put(`/sean/uploads/${upload_id}/chunk?index=${i}`, chunk, {
      headers: { ...headers, "Content-Type": "application/octet-stream" },
    });
    onProgress?.(Math.round(((i + 1) / total) * 95));
  }
  const done = await api.post(`/sean/uploads/${upload_id}/complete`, null, { headers }).then((r) => r.data);
  onProgress?.(100);
  return done;
}
